import { IMetaDataProps, IMetaTagItem } from 'shared-interfaces'

export const socialTags = (props: IMetaDataProps): IMetaTagItem[] => {
    const { openGraphType, url, title, description, image } = props
    const metaTags: IMetaTagItem[] = [
        {
            name: 'twitter:card',
            content: 'summary_large_image',
            property: '',
            type: 'twitter',
            key: 'twcard',
        },
        {
            name: 'twitter:site',
            content: '@custodian_club',
            property: '',
            type: 'twitter',
            key: 'twhandle',
        },
        {
            name: 'twitter:title',
            content: title ? title : '',
            property: '',
            type: 'twitter',
            key: 'twtitle',
        },
        {
            name: 'twitter:description',
            content: description ? description : '',
            property: '',
            type: 'twitter',
            key: 'twdesc',
        },
        {
            name: 'twitter:creator',
            content: '@custodian_club',
            property: '',
            type: 'twitter',
            key: 'twcreator',
        },
        {
            name: 'twitter:image:src',
            content: image ? image : '',
            property: '',
            type: 'twitter',
            key: 'twimg',
        },
        // duplicate
        // {
        //     name: 'twitter:card',
        //     content: 'summary_large_image',
        //     property: '',
        //     type: 'twitter',
        //     key: '',
        // },
        {
            property: 'og:title',
            content: title ? title : '',
            name: '',
            type: 'open_graph',
            key: 'ogtitle',
        },
        {
            property: 'og:type',
            content: openGraphType ? openGraphType : '',
            name: '',
            type: 'open_graph',
            key: 'ogtype',
        },
        {
            property: 'og:url',
            content: url ? url : '',
            name: '',
            type: 'open_graph',
            key: 'ogurl',
        },
        {
            property: 'og:image',
            content: image ? image : '',
            name: '',
            type: 'open_graph',
            key: 'ogimage',
        },
        {
            property: 'og:description',
            content: description ? description : '',
            name: '',
            type: 'open_graph',
            key: 'ogdesc',
        },
        {
            property: 'og:site_name',
            content: 'Custodian - manage your car from anywhere.',
            name: '',
            type: 'open_graph',
            key: 'ogsitename',
        },
    ]

    return metaTags
}
